
///('DEFAULT MATERIALSERVICE');

seedWebServices.service('MaterialService', ['$resource', '$uibModal', '$http', '$cacheFactory',
function ($resource, $uibModal, $http, $cacheFactory) {

    var serviceCache = $cacheFactory('MaterialService');
    var baseUrl = '../Api/Material';

    this.getName = function () {
        return 'MaterialService';
    };


    this.resetCache = function () {
        //console.log('StoreServiceResetCache');
        serviceCache.removeAll();
    };

    //START MATERIALS
    this.getMaterialsCount = function () {
        return $http.get(baseUrl + '/GetMaterialsCount', {
            params: {},
            cache: serviceCache
        });
    };

    this.getMaterials = function (filterString, options, skipNumber, takeNumber, sort) {
        return $http.put(baseUrl + '/SearchMaterials', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort }, { cache: serviceCache });
    };

    this.getMaterialSkus = function (filterString, options, skipNumber, takeNumber, sort, contactID) {
        return $http.put(baseUrl + '/SearchMaterialSkus',
            { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort, contactID: contactID },
            { cache: serviceCache }
        );
    };

    this.getMaterialSkusCount = function () {
        return $http.get(baseUrl + '/GetMaterialSkusCount', {
            params: {},
            cache: serviceCache
        });
    };

    this.getPrices = function (filterString, options, skipNumber, takeNumber, sort) {
        return $http.put(baseUrl + '/SearchPrices', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort }, { cache: serviceCache });
    };

    this.getMaterialsColumns = function (column, filterString, skipSize, takeSize) {
        return $http.get(baseUrl + '/GetMaterialsColumns', {
            params: { column: column, filterString: filterString, skipSize: skipSize, takeSize: takeSize },
            cache: serviceCache
        });
    };
    //END MATERIALS

    //START POs
    this.getPOs = function (filterString, options, skipNumber, takeNumber, sort, purchaseID) {
        return $http.put(baseUrl + '/SearchPOs', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort, purchaseID: purchaseID }, { cache: serviceCache });
    };

    this.getPOsArchived = function (filterString, options, skipNumber, takeNumber, sort, purchaseID) {
        return $http.put(baseUrl + '/SearchPOs', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort, purchaseID: purchaseID, showClosed: true }, { cache: serviceCache });
    };

    this.getPOsColumns = function (column, filterString, skipSize, takeSize) {
        return $http.get(baseUrl + '/GetPOsColumns', {
            params: { column: column, filterString: filterString, skipSize: skipSize, takeSize: takeSize },
            cache: serviceCache
        });
    };

    this.getPOsCount = function () {
        return $http.get(baseUrl + '/GetPOsCount', {
            params: {},
            cache: serviceCache
        });
    };
    //END POs

    //START STOCKS ---------------------------------------------------------------------------------
    this.getStocks = function (filterString, options, skipNumber, takeNumber, sort, materialID) {
        return $http.put(baseUrl + '/SearchStocks', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort, materialID: materialID }, { cache: serviceCache });
    };

    this.getStocksColumns = function (column, filterString, skipSize, takeSize) {
        return $http.get(baseUrl + '/GetStocksColumns', {
            params: { column: column, filterString: filterString, skipSize: skipSize, takeSize: takeSize },
            cache: serviceCache
        });
    };

    this.getStocksCount = function () {
        return $http.get(baseUrl + '/GetStocksCount', {
            params: {},
            cache: serviceCache
        });
    };
    //END STOCKS ----------------------------------------------------------------------------------------

    //START ALLOCATIONS
    this.getAllocations = function (filterString, options, skipNumber, takeNumber, sort) {
        return $http.put(baseUrl + '/SearchAllocations', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort }, { cache: serviceCache });
    };

    this.getAllocationColumns = function (column, filterString, skipSize, takeSize) {
        return $http.get(baseUrl + '/GetAllocationColumns', {
            params: { column: column, filterString: filterString, skipSize: skipSize, takeSize: takeSize },
            cache: serviceCache
        });
    };

    this.getAllocationCounts = function () {
        return $http.get(baseUrl + '/GetAllocationCounts', {
            params: {},
            cache: serviceCache
        });
    };
    //END ALLOCATIONS

    //MATERIAL TYPEAHEAD
    this.getMaterialsQuery = function (query) {
        return $http.get(baseUrl + '/GetMaterialsQuery', {
            params: { query: query },
            cache: false
        });
    };

    this.getMaterialAlternatives = function (materialID) {
        return $http.get(baseUrl + '/GetMaterialAlternatives', {
            params: { materialID: materialID },
            cache: false
        });
    };

    this.getMaterialAllocs = function (materialID) {
        return $http.get(baseUrl + '/GetMaterialAllocs', {
            params: { materialID: materialID },
            cache: false
        });
    };

    this.getMaterial = function (materialID) {
        return $http.get(baseUrl + '/GetMaterial', {
            params: { materialID: materialID },
            cache: false
        });
    };

    this.getStorages = function () {
        return $http.get(baseUrl + '/GetStorages', {
            cache: false
        });
    };

    this.getDrawings = function () {
        return $http.get(baseUrl + '/GetDrawings', {
            cache: false
        });
    };

    this.recalcAllocs = function (materialID) {
        return $http.get(baseUrl + '/RecalcAllocs', {
            params: { materialID: materialID },
            cache: false
        });
    };

    this.openMaterialModal = function (materialID) {
        $uibModal.open({
            templateUrl: './SPA/materials/materialModal.html',
            controller: 'MaterialModalCtrl',
            size: 'lg',
            resolve: {
                materialID: function () {
                    return materialID;
                }
            }
        });
    };

    this.saveMaterial = function (material) {
        return $http.post(baseUrl + '/SaveMaterial', material, true);
    };

    this.getRefers = function (filterString, options, skipNumber, takeNumber, sort) {
        return $http.put(baseUrl + '/GetRefers',
            { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort },
            { cache: serviceCache }
        );
    };

    this.getRefersCount = function () {
        return $http.get(baseUrl + '/GetRefersCount', {
            cache: false
        });
    };

    this.getSkuFilters = function (contactID) {
        return $http.get(baseUrl + '/GetSkuFilters', {
            params: { contactID: contactID },
            cache: serviceCache
        });
    };

    this.recalcPrices = function (contactID, incotermID, pointID, dateStart, dateEnd, forceApi) {
        var data = {
            contactID: contactID,
            incotermID: incotermID,
            pointID: pointID,
            dateStart: dateStart,
            dateEnd: dateEnd,
            forceApi: forceApi,
        };
        return $http.put(baseUrl + '/RecalcPrices',
            data,
            { cache: serviceCache }
        );
    };

    this.getSkusQuery = function (query, contactID) {
        return $http.get(baseUrl + '/GetSkusQuery', {
            params: { query: query, contactID: contactID },
            cache: false
        });
    };

}]);
